// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "changeSet": "2808",
    "buildNumber": "4106",
    "buildJob": "Faceted-Search-UI",
    "buildAgent": "TFS",
    "buildTime": "01/13/2021 16:10:17"
};
/* tslint:enable */



// WEBPACK FOOTER //
// ./src/environments/version.ts